module.exports = __webpack_public_path__ + "static/media/forgot.ef9036fc.png";